export const FIELD_LABELS = {
  sendEmail: "Envío de email activado",
  minsize_q25: "Tamaño mín. Q25",
  maxspread_q75: "Spread máx. Q75",
  mibparamdate: "Fecha parámetro",
  toll_withinday: "Peaje intradiario",
  toll_monthly: "Peaje mensual",
  toll_daily: "Peaje diario",
  toll_quarterly: "Peaje trimestral",
  toll_yearly: "Peaje anual",
  settle: "Último precio",
  settle_bid: "Bid",
  settle_ask: "Ask",
  settle_quality_factor: "Factor calidad",
};
